import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Shield, Clock, BadgeCheck, ThumbsUp, Sparkles } from "lucide-react";

const credentials = [
  { icon: Shield, label: "Travail professionnel", description: "Expertise et savoir-faire dans chaque détail" },
  { icon: BadgeCheck, label: "Respect du budget", description: "Transparence totale et aucune surprise" },
  { icon: Clock, label: "Respect des délais", description: "Livraison dans les échéances convenues" },
  { icon: ThumbsUp, label: "Satisfaction client", description: "Une réputation bâtie sur l'excellence" },
  { icon: Sparkles, label: "Finition impeccable", description: "Le souci du détail qui fait la différence" },
];

export const CredibilitySection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section className="py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A] border-t border-b border-[#2A2A2A]/30" data-testid="credibility-section" ref={ref}>
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="mb-16"
        >
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#E8891C] mb-4">Nos engagements</p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#F5F5F0] tracking-tight" data-testid="credibility-title">
            La confiance, <span className="italic">notre fondation</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-6">
          {credentials.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1, ease: "easeOut" }}
              className="group text-center md:text-left"
              data-testid={`credibility-item-${index}`}
            >
              <div className="inline-flex items-center justify-center w-12 h-12 border border-[#2A2A2A] mb-5 group-hover:border-[#E8891C] transition-colors duration-500">
                <item.icon size={20} className="text-[#E8891C]" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-lg text-[#F5F5F0] mb-2 group-hover:text-[#E8891C] transition-colors duration-500">{item.label}</h3>
              <p className="font-sans text-sm text-[#A1A1AA] leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
